import type { CONTENT_STRUCTURE_WITH_DATA } from '../../types/Blocks'
import type { GOOGLE_MAP_ADVANCED_MARKER_DATA, GOOGLE_MAP_ADVANCED_MARKER_PARAMS, GOOGLE_MAP_DATA, GOOGLE_MAP_INFOBOX_DATA, GOOGLE_MAP_PARAMS, GOOGLE_MAP_PATH_DATA } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'

export const DEFAULT_GOOGLE_MAP_INFOBOX_DATA = (): GOOGLE_MAP_INFOBOX_DATA => ({
  type: 'map-infobox',
  latitude: null,
  longitude: null,
  data: {
    value: null,
  },
})

export const DEFAULT_GOOGLE_MAP_PATH_DATA = (): GOOGLE_MAP_PATH_DATA => ({
  type: 'map-path',
})

export const DEFAULT_GOOGLE_MAP_ADVANCED_MARKER_DATA = (): GOOGLE_MAP_ADVANCED_MARKER_DATA => ({
  type: 'advanced-marker',
  showInfobox: false,
  latitude: null,
  longitude: null,
  description: null,
})

export const DEFAULT_GOOGLE_MAP_ADVANCED_MARKER_PARAMS = (): GOOGLE_MAP_ADVANCED_MARKER_PARAMS => ({
  color: null,
  backgroundColor: null,
  borderColor: null,
})

export const DEFAULT_GOOGLE_MAP_CHILDS = (): CONTENT_STRUCTURE_WITH_DATA<
  GOOGLE_MAP_ADVANCED_MARKER_PARAMS,
  GOOGLE_MAP_ADVANCED_MARKER_DATA
>[] => [
  {
    type: 'block',
    params: DEFAULT_GOOGLE_MAP_ADVANCED_MARKER_PARAMS(),
    data: DEFAULT_GOOGLE_MAP_ADVANCED_MARKER_DATA(),
    interactions: {},
    dynamicData: {},
    children: [],
  },
]

export const DEFAULT_GOOGLE_MAP_DATA = (): GOOGLE_MAP_DATA => ({
  id: null,
  classes: null,
  type: 'google-map',
  zoom: {
    value: 15,
    unit: '%',
  },
  latitude: null,
  longitude: null,
})

const DEFAULT_GOOGLE_MAP_PARAMS_DEVICE = () => ({
  hidden: false,
  width: DEFAULT_WIDTH(),
  height: {
    value: 400,
    unit: 'px',
  },
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
})

export const DEFAULT_GOOGLE_MAP_PARAMS = (): GOOGLE_MAP_PARAMS => ({
  pc: DEFAULT_GOOGLE_MAP_PARAMS_DEVICE(),
  tablet: DEFAULT_GOOGLE_MAP_PARAMS_DEVICE(),
  mobile: DEFAULT_GOOGLE_MAP_PARAMS_DEVICE(),
})
